import { api, apiMipe } from '@/core/api/';
import circleAlertTypes from '@/utils/constants/circleAlertTypes';

const circleArray = [
  circleAlertTypes.CircleOne,
  circleAlertTypes.CircleTwo,
  circleAlertTypes.CircleThree,
  circleAlertTypes.CircleFour,
];
export default {
  async fetchAlerts() {
    const { data: response } = await apiMipe.get('api/alert');
    if (response) {
      let index = 0;
      return response.map((item) => {
        if (index >= circleArray.length) index = 0;
        item.type = circleArray[index];
        index++;
        return item;
      });
    }
  },
  /**
   *
   * @param { alertTypeId, PageSize, PageIndex } filters
   */
  async fetchAlertsByType(filters) {
    const { data: response } = await apiMipe.get(
      `api/alert/${filters.alertTypeId}`,
      {
        params: {
          pageIndex: filters.pageIndex,
          pageSize: filters.pageSize,
        },
      }
    );
    if (response) {
      return response;
    }
  },
  fetchMessages() {
    return api.get('api/message/mesaggefordashboard');
  },
  fetchSchedule(date, applicationId) {
    return apiMipe.get('api/calendarEvent/dailyevents/', {
      params: {
        date: date,
        applicationId,
      },
    });
  },
  saveReadMessage(messageId) {
    return apiMipe.post(`api/message/savemessageread/${messageId}`);
  },
  getEnrollmentCount() {
    return apiMipe.get('api/dashboard/enrollmentprovidercount');
  },
  getEvents(params) {
    return apiMipe.get('api/dashboard/events', { params });
  },
  getWorkshops(params) {
    return apiMipe.get('api/dashboard/workshops', { params });
  },
  getNews(params) {
    return apiMipe.get('api/dashboard/news', { params });
  },
  getEducationalMaterials(params) {
    return apiMipe.get('api/dashboard/educationalmaterials', { params });
  },
  getEducationalMaterialCategories(params) {
    return apiMipe.get('api/dashboard/educationalmaterials/categories', {
      params,
    });
  },
  getAlerts(params) {
    return apiMipe.get('api/dashboard/alerts', { params });
  },
  fetchUnreadMessages(params) {
    return apiMipe.get('api/dashboard/messagecount', { params });
  },
  getTeachingMaterial(params) {
    return apiMipe.get('api/dashboard/teachingmaterial', { params });
  },
  markMessages(payload) {
    return apiMipe.post(`api/message/mark`, payload);
  },
  getGraphics(params) {
    return apiMipe.get('api/dashboard/graphics', { params });
  },
  getGraphicByReportType(id) {
    return apiMipe.get(`api/dashboard/graphics/reportTypes/${id}`);
  },
  getSections(params) {
    return apiMipe.get(`api/dashboard/sections`, { params });
  },
};
